/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var mobileReturnFocus = null;

  function visibleFocusableElements(container) {
    if (!container) {
      return [];
    }

    return Array.prototype.filter.call(container.querySelectorAll(focusableSelector), function (element) {
      return element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null;
    });
  }

  function mobileMenuToggle(menu) {
    return document.querySelector('[aria-controls="' + menu.id + '"]');
  }

  function activeMobilePanel(menu) {
    var openPanels = menu.querySelectorAll('.mobile-menu__panel.is-open');
    return openPanels.length > 0 ? openPanels[openPanels.length - 1] : menu.querySelector('.mobile-menu__panel:not(.is-nested)');
  }

  function closeDesktopMenus() {
    var condensedToggle = document.querySelector('.header__desktop-nav-toggle[aria-expanded="true"]');
    if (condensedToggle) {
      condensedToggle.click();
      condensedToggle.focus();
      return true;
    }

    var openMenus = document.querySelectorAll('.header [data-type="menu"][aria-hidden="false"]');
    if (openMenus.length === 0) {
      return false;
    }

    var controller = document.querySelector('[aria-controls="' + openMenus[openMenus.length - 1].id + '"]');

    Array.prototype.forEach.call(openMenus, function (menu) {
      menu.setAttribute('aria-hidden', 'true');
      menu.classList.remove('nav-dropdown--glued');

      var trigger = document.querySelector('[aria-controls="' + menu.id + '"]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    Array.prototype.forEach.call(document.querySelectorAll('.header .is-dropdown-open'), function (item) {
      item.classList.remove('is-dropdown-open');
    });

    if (controller) {
      controller.focus();
    }

    return true;
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) {
      return;
    }

    var backButton = event.target.closest('[data-action="close-panel"]');
    if (!backButton) {
      return;
    }

    var panel = backButton.closest('.mobile-menu__panel');
    var panelTrigger = panel ? document.querySelector('[aria-controls="' + panel.id + '"]') : null;
    if (panelTrigger) {
      window.requestAnimationFrame(function () {
        panelTrigger.focus();
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    var menu = document.querySelector('.mobile-menu[aria-hidden="false"]');

    if (menu) {
      if (event.key === 'Escape') {
        event.preventDefault();

        var panel = activeMobilePanel(menu);
        var backButton = panel && panel.classList.contains('is-nested') ? panel.querySelector('[data-action="close-panel"]') : null;

        if (backButton) {
          var panelTrigger = document.querySelector('[aria-controls="' + panel.id + '"]');
          backButton.click();
          if (panelTrigger) {
            panelTrigger.focus();
          }
        } else {
          var toggle = mobileMenuToggle(menu);
          if (toggle) {
            toggle.click();
            toggle.focus();
          }
        }
        return;
      }

      if (event.key === 'Tab') {
        var focusables = visibleFocusableElements(activeMobilePanel(menu));
        if (focusables.length === 0) {
          return;
        }

        var first = focusables[0];
        var last = focusables[focusables.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
      return;
    }

    if (event.key === 'Escape') {
      closeDesktopMenus();
    }
  });

  var navigationObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var target = mutation.target;

      if (target.classList && target.classList.contains('mobile-menu') && mutation.attributeName === 'aria-hidden') {
        var toggle = mobileMenuToggle(target);

        if (target.getAttribute('aria-hidden') === 'false') {
          mobileReturnFocus = toggle || document.activeElement;
          window.requestAnimationFrame(function () {
            var focusables = visibleFocusableElements(activeMobilePanel(target));
            if (focusables.length > 0) {
              focusables[0].focus();
            }
          });
        } else if (target.contains(document.activeElement) && mobileReturnFocus) {
          mobileReturnFocus.focus();
        }
      }

      if (target.classList && target.classList.contains('mobile-menu__panel') && mutation.attributeName === 'class' && target.classList.contains('is-open')) {
        window.requestAnimationFrame(function () {
          var focusables = visibleFocusableElements(target);
          if (focusables.length > 0) {
            focusables[0].focus();
          }
        });
      }
    });
  });

  function observeMobileNavigation(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.mobile-menu'), function (menu) {
      navigationObserver.observe(menu, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });

      Array.prototype.forEach.call(menu.querySelectorAll('.mobile-menu__panel'), function (panel) {
        navigationObserver.observe(panel, {
          attributes: true,
          attributeFilter: ['class']
        });
      });
    });
  }

  observeMobileNavigation(document);

  document.addEventListener('shopify:section:load', function (event) {
    observeMobileNavigation(event.target);
  });
})();
